import React from 'react'
import PropTypes from 'prop-types'
import {
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    List,
    ListItem,
    Text,
    Flex
} from '@chakra-ui/react'
import {PlusIcon, MinusIcon, InfoIcon, DeliveryIcon} from '../../../components/custom-icons'
import {Component} from '@salesforce/commerce-sdk-react/components'

/**
 * PDC Delivery Methods And Returns component
 * @param {string} title - Title
 * @param {string} warning - Warning
 * @param {object} regions - Regions
 * @returns {JSX.Element} - PDC Anchors Block component
 */
export const PDCDeliveryMethodsAndReturns = ({title, warning, regions}) => {
    let components = []
    if (regions) {
        components = regions[0].components || []
    }

    return (
        <AccordionItem mt="-1px">
            {({isExpanded}) => (
                <>
                    <AccordionButton py="24px" px="16px">
                        <Flex justifyContent={'space-between'} w="full" alignItems="center">
                            <Flex alignItems={'center'}>
                                <DeliveryIcon boxSize="32px" />
                                <Text
                                    as="span"
                                    align="left"
                                    variant="eyeBrowSmall"
                                    textTransform={'uppercase'}
                                    ml="12px"
                                    mr="10px"
                                    role="heading"
                                    aria-level="2"
                                >
                                    {title}
                                </Text>
                            </Flex>
                            {isExpanded ? (
                                <MinusIcon boxSize="12px" />
                            ) : (
                                <PlusIcon boxSize="12px" />
                            )}
                        </Flex>
                    </AccordionButton>
                    <AccordionPanel p="0 0 24px 16px" listStyleType={'none'}>
                        <List mr="16px">
                            {components &&
                                components.length > 0 &&
                                components.map((component, i) => (
                                    <ListItem key={component.id}>
                                        <Component component={component} />
                                    </ListItem>
                                ))}
                        </List>
                        <Flex pt="8px">
                            <InfoIcon boxSize="16px" mr="8px" />
                            <Text variant={'bodySmall'} color="darkGray">
                                {warning}
                            </Text>
                        </Flex>
                    </AccordionPanel>
                </>
            )}
        </AccordionItem>
    )
}

PDCDeliveryMethodsAndReturns.propTypes = {
    title: PropTypes.string,
    warning: PropTypes.string,
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.object,
                    id: PropTypes.string,
                    typeId: PropTypes.string
                })
            )
        })
    )
}
